import { useState, useContext } from "react";
import { Mail, X, RefreshCw } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { API, AuthContext } from "@/App";

const EmailVerificationBanner = () => {
  const { user, token } = useContext(AuthContext);
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  // Don't show if user is verified, dismissed, or no user
  if (!user || user.email_verified || dismissed) {
    return null;
  }

  const t = (es, ca) => user.language === "ca" ? ca : es;

  const handleResend = async () => {
    setSending(true);
    try {
      await axios.post(`${API}/auth/resend-verification`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success(t(
        "Email de verificación enviado",
        "Email de verificació enviat"
      ));
    } catch (error) {
      console.error("Resend error:", error);
      toast.error(t(
        "Error al enviar el email",
        "Error en enviar l'email"
      ));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-gradient-to-r from-amber-500/20 to-orange-500/20 border-b border-amber-500/30">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Mail className="w-5 h-5 text-amber-400 flex-shrink-0" />
            <p className="text-sm text-amber-100">
              {t(
                "Por favor, verifica tu email para completar el registro.",
                "Si us plau, verifica el teu email per completar el registre."
              )}
            </p>
          </div>
          
          <div className="flex items-center gap-2">
            <button
              onClick={handleResend}
              disabled={sending}
              className="flex items-center gap-1 text-xs text-amber-300 hover:text-amber-200 transition-colors disabled:opacity-50"
            >
              <RefreshCw className={`w-3 h-3 ${sending ? 'animate-spin' : ''}`} />
              {t("Reenviar", "Reenviar")}
            </button>
            
            <button
              onClick={() => setDismissed(true)}
              className="text-amber-400/60 hover:text-amber-300 transition-colors p-1"
              aria-label="Dismiss"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
